module.exports = __webpack_public_path__ + "img/yalong1.d1804900.png";